export default "images/residential suite.jpg";